/* Zyndia: show prices as ₹1,099 (no paise) everywhere on the storefront while the shop's money format is still "Rs. {{amount}}".
   Rewrites text nodes as they arrive, so it also covers cart drawer / quick-view updates. Becomes a no-op once the
   admin money format is changed to ₹. */
(function () {
  var RE = /Rs\.?\s?(\d[\d,]*)(?:\.(\d{1,2}))?(\s?INR\b)?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
  function fmt(whole, paise) {
    var n = parseInt(String(whole).replace(/,/g, ''), 10);
    if (isNaN(n)) return null;
    if (paise && parseInt(paise, 10) >= 50) n += 1;
    return '₹' + n.toLocaleString('en-IN');
  }
  function fix(node) {
    var t = node.nodeValue;
    if (!t || t.indexOf('Rs') === -1) return;
    var out = t.replace(RE, function (m, w, p) { var f = fmt(w, p); return f === null ? m : f; });
    if (out !== t) node.nodeValue = out;
  }
  function walk(el) {
    if (!el) return;
    if (el.nodeType === 3) return fix(el);
    if (el.nodeType !== 1 || SKIP[el.nodeName]) return;
    var w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) { var p = n.parentNode; if (!p || SKIP[p.nodeName]) continue; fix(n); }
  }
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var m = list[i];
      if (m.type === 'characterData') fix(m.target);
      else for (var j = 0; j < m.addedNodes.length; j++) walk(m.addedNodes[j]);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  if (document.body) walk(document.body);
  document.addEventListener('DOMContentLoaded', function () { walk(document.body); });
})();
